require('./myIconsView.scss');

const React = require('react');

class MyIconsView extends React.Component {
    constructor(props) {
        super(props);

        this.buildIcons = this.buildIcons.bind(this);

        this.state = {
            icons: [
                'porcentaje',
                'euro',
                'ayuda-urgente',
                'restaurantes',
                'subir-imagen',
                '015-tae',
                'tarjetas',
                'activar-tarjeta',
                'desactivar-tarjeta',
                'contacto-clientes',
                'contacto-inversiones',
                'contacto-no-clientes',
                'contacto-whatsapp',
                '1de7',
                '2de7',
                '3de7',
                '4de7',
                '5de7',
                '6de7',
                '7de7',
                'sin-renovacion',
                'fondos-inversion',
                'facebook',
                'google-plus',
                'instagram',
                'linkedin',
                'twitter',
                'whatsapp',
                'youtube',
                'cuentas',
                'acciones-internacionales',
                'beneficios-monetarios',
                'depositos',
                'estrategia',
                'interes-competitivo',
                'mas-productos',
                'oferta-futuros',
                'tarifa-especial',
                'transparencia',
                's-calcular',
                's-compartir',
                'accordion-cerrar',
                'accordion-abrir',
                'anterior',
                'siguiente',
                'breadcrumb',
                'alza',
                'baja',
                'dropdown-cerrar',
                'dropdown-abrir',
                's-beneficiarios',
                's-buscar',
                's-editar',
                's-estrella',
                's-media-estrella',
                's-llamar',
                's-locacion',
                's-correo',
                's-op-comp',
                's-op-comp-horizontal',
                's-pin',
                's-ruta',
                's-mi-locacion',
                'beneficiario',
                '03-tae',
                '06-tae',
                '07-tae',
                '09-tae',
                '9-76-tae',
                '099-euribor',
                '0-euro',
                '1-euro',
                '1-interes',
                '2-interes',
                'exito',
                'error',
                'informacion',
                'advertencia',
                'pregunta',
                'buscar',
                'llamar',
                'editar',
                'copiar',
                'filtrar',
                'calcular',
                'agregar',
                'quitar',
                'mostrar',
                'ocultar',
                'cerrar',
                'volver',
                'colapsar',
                'expandir',
                'descargar',
                'subir',
                'salir',
                'devolver',
                'transferir',
                'flecha-izquierda',
                'flecha-derecha',
                'refrescar',
                'compartir',
                'anular-doc',
                'deslizar',
                'imprimir',
                'eliminar',
                'reproducir',
                'ampliar',
                'agregar-agenda',
                'glosario',
                'pdf',
                'dinero',
                'documento',
                'candado',
                'movil',
                'formacion-profesional',
                'identidad',
                'iban',
                'videoconferencia',
                'correos',
                'correo',
                'locacion',
                'huella-digital',
                'descuento',
                'tendencia-neutral',
                'tendencia-baja',
                'tendencia-alza',
                'wallet',
                'calendario',
                'notificaciones',
                'preferencias',
                'ruta',
                'tiempo',
                'recibo',
                'firma',
                'cajero',
                'especialista',
                'de-movilamovil',
                'comodidad',
                'libertad-cambio',
                'adaptado-necesidades',
                'diversificacion',
                'ahorrar-tiempo',
                'amortiza',
                'erasmus',
                'seguro-accidentes',
                'universidad',
                'simplificar',
                'global',
                'analisis-tecnico',
                'imprevistos',
                'compras-seguras',
                'rentabilidad',
                'flexibilidad',
                'ahorra-dinero',
                'posgrado',
                'transporte-automacion',
                'nitidez',
                'luz-natural',
                'superficie-plana',
                'mov-excluidos',
                'eduacion-salud-belleza',
                'casa-hogar',
                'ingresos',
                'otros-gastos',
                'banco-ong-seguros',
                'comercio-tiendas',
                'viajes',
                'inversiones-ahorros',
                'icon-rotar-imagen'
            ]
        };
    }

    buildIcons() {
        const { icons } = this.state;

        return icons.map((icon, index) => {
            // (andres): There icons that needs two classes
            icon = icon.replace('.', ' ');

            const iconClassName = `icon-${icon}`;
            return (
                <div key={index}>
                    <span className={iconClassName}></span>
                    <label>.{iconClassName}</label>
                </div>
            );
        });
    }

    render() {
        const icons = this.buildIcons();

        return (
            <div className="my-icons-view">
                {icons}
            </div>
        );
    }
}

module.exports = MyIconsView;
